import { Button, Input, InputGroup } from 'reactstrap';
import { useRef, useState, useEffect } from 'react';
import _ from 'lodash';

export default function BlurableNumberInput({
  value,
  onChange,
  name,
  children,
  disabled,
  step,
  onEditBegin,
  onEditEnd,
  wideClickable,
  isGothiaMode,
}) {
  const [editState, setEditState] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const inputRef = useRef(null);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  if (editState) {
    return (
      <>
        <InputGroup className="w-100">
          <Input
            type="number"
            className="d-inline border-0
             text-center"
            inputMode="decimal"
            title="Endast siffror tack :)"
            pattern="[0-9]*"
            value={inputValue}
            onBlur={() => {
              setEditState(false);
              onChange(name, inputValue);
            }}
            onKeyDown={event => {
              if (event.key === 'Enter') {
                onChange(name, inputValue);
                setEditState(false);
                onEditEnd();
              }
              if (event.key === 'Escape') {
                setInputValue(value);
                setEditState(false);
                onEditEnd();
              }
            }}
            onChange={e => setInputValue(_.toNumber(e.target.value))}
            innerRef={inputRef}
            step={step}
          />

          <Button
            disabled={inputValue < 0}
            onMouseDown={() => {
              onChange(name, inputValue);
              setEditState(false);
              onEditEnd();
            }}
          >
            Ok
          </Button>
        </InputGroup>
      </>
    );
  }

  if (isGothiaMode) {
    return (
      <Button
        role="presentation"
        color="primary"
        outline
        block
        size="sm"
        disabled={disabled}
        onKeyDown={event => {
          event.preventDefault();
        }}
        className={`mx-1
         ${wideClickable ? 'text-center' : 'text-end'}`}
        onClick={async event => {
          if (disabled) return;
          event.preventDefault();
          await setEditState(true);
          await onEditBegin();
          inputRef.current.focus();
          inputRef.current.select();
        }}
      >
        {children}
      </Button>
    );
  }
  return (
    <div
      role="presentation"
      onKeyDown={event => {
        event.preventDefault();
      }}
      className={`d-inline w-100 h-100 border-0 ${
        wideClickable ? 'text-center' : 'text-end'
      }`}
      style={{ cursor: 'pointer' }}
      onClick={async event => {
        if (disabled) return;
        event.preventDefault();
        await setEditState(true);
        await onEditBegin();
        inputRef.current.focus();
        inputRef.current.select();
      }}
    >
      {children}
    </div>
  );
}
